import { render, staticRenderFns } from "./OverlayPictureViewer.vue?vue&type=template&id=0b8f3b02&scoped=true&"
import script from "./OverlayPictureViewer.vue?vue&type=script&lang=ts&"
export * from "./OverlayPictureViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8f3b02",
  null
  
)

export default component.exports